const captchaInfo = {
  siteKey: "6LdaOW8rAAAAAKxzdCekXAxRKcXpNbdPvTtLBfPh",
};

export default captchaInfo;
